import { Subject } from 'rxjs';

export const searchValueObserver = new Subject<string>();
